import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

import { nomService } from '../../services/api/nom.service';
import { preauthorizationService } from '../../services/api/preauthorization.service';

import { utils } from "../../services/helpers/utils"
export const PreauthorizationForms = (props) => {

    const [dbList, setDbList] = useState([]);
    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([])
    const [dropdown, setDropdown] = useState([])
    const [investigatiiFormulare, setInvestigatiiFormulare] = useState([]);
    const investigatii = props.investigatii ?? [];

    useEffect(() => {
        if (props && props.id) {
            preauthorizationService.getForms({
                    preauthorizationId: props.id
                }).then(response => {
                    if (response) {
                        setDbList(response);
                        setList(response);
                        props.setFormulare(response);
                    }

                });
        }
    }, [props.refresh]);

    useEffect(() => {
        if (props && props.partener) {
            preauthorizationService.getInvestigationsForms({ partener: props.partener })
                .then(response => {
                    if (response) {
                        setInvestigatiiFormulare(response);
                    }
                });
        }
    }, []);

    useEffect(() => {
       
        nomService.getForms()
            .then(response => {
                if (response) {
                    // Setez dropdownul
                    setDropdown(response);
                }
            });
    }, []);

    useEffect(() => {
        if (list.length > 0 && dropdown.length > 0) {
            var d = [];
            for (var item in list) {
                var el = utils.findObjectById(dropdown, list[item].idFormular)
                d.push(el);
            }
            setDefaults(d);
        }
    }, [list, dropdown])

    useEffect(() => {
        /* Trebuie sa ia lista de investigatii si formulare  */
        let formulare = [...dbList];
        let nrFisiere = 0;  

        if (investigatii.length == 0) {
            setList([]);
        }
        

        if (investigatii && investigatii.length > 0 && investigatiiFormulare.length > 0) {

            for (let i = 0; i < investigatii.length; i++) {
                let found = false;
                let idFormular = 0;
                // Daca abia a fost adaugata investigatia n-are rost sa cautam ceva
                if (investigatii[i].idInvestigatie == 0) {
                    continue
                }

                for (let j = 0; j < investigatiiFormulare.length; j++) {
                    if (investigatii[i].idInvestigatie == investigatiiFormulare[j].idInvestigatie) {
                        found = true;
                        idFormular = investigatiiFormulare[j].idFormular;
                        break;
                    }
                }

                if (found) {

                    const index = formulare.findIndex(object => object.idFormular === idFormular);

                    if (index === -1) {
                        formulare.push(
                            { id:0, idFormular: idFormular, idPreautorizare : 0 }
                        )
                    }
                    
                    if (investigatiiFormulare.nrFisiere > nrFisiere) {
                        nrFisiere = investigatiiFormulare.nrFisiere;
                    }
                }
            }
            
            setList(formulare);
            props.setFormulare(formulare);
            props.setNrFisiere( nrFisiere )

        }



    }, [investigatii])



    return (
        <div className="pt20">
            <fieldset>
                <legend className="pb5">Formulare</legend>
                <table className="tbl tbladd mt5" data-name="lista_formulare" width="100%">
                    <thead>
                        <tr>
                            <th>Formular</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) => (
                            <tr key={index}>
                                <td className="col90p">
                                    <DropDownList
                                        data={dropdown}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        name="idFormular"
                                        className="text w550 fl"
                                        disabled={ true}
                                    />
                                </td>
                              
                            </tr>
                        ))}
                    </tbody>
                </table>
            </fieldset>
        </div>
    );
}

